import React, { useState, useEffect } from 'react';
import './studentEligibility.css';
import {
  Grid,
  Toolbar,
  makeStyles,
  Typography,
  Box,
  Button,
} from '@material-ui/core';
import KenDialog from '../../../../global_components/KenDialogBox';
import KenLoader from '../../../../Components/KenLoader/index';
import KenGrid from '../../../../global_components/KenGrid';
import KenSelect from '../../../../global_components/KenSelect';
import KenCheckbox from '../../../../global_components/KenCheckbox/index';
import KenButton from '../../../../global_components/KenButton';
import KenSnackbar from '../../../../global_components/KenSnackbar';
import KenCard from '../../../../global_components/KenCard';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';

import {
  getDataForCourseEnrolment,
  getDataForStudentEnrolment,
  getstudentPromotionCriteriaData,
  getPromotionCriteriaDataFilter,
} from '../../../../Utils/apiServices';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
    width: '100%',
  },
  title: {
    color: '##272727',
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  facultyInfoSection: {
    background: '#fff',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      color: 'white',
      background: 'rgba(241, 75, 45, 0.2)',
    },
  },
  // criteriafilter: {
  //   display: 'flex',
  //   justifyContent: 'space-between',
  //   padding: '5px',
  // },
  // filterBy: {
  //   padding: '5px',
  // },
  errorcell: {
    background: 'orange',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      background: 'green',
      color: 'white',
    },
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  promoteAllBtn: {
    float: 'right',
    marginTop: '1rem',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    background: '##272727 !important',
    color: '#fff',
    borderRadius: '5px',
    marginLeft: 'auto',
  },
  searchFilter: {
    position: 'absolute',
    right: '10px',
    width: '300px',
  },
  courseList: {
    minHeight: '45px',
    background: '#fff',
    marginTop: '10px',
    marginBottom: '10px',
    width: '100%',
  },
  tableText: {
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '58%',
    transform: 'translate(-50%, -50%)',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    marginTop: '24px',
    marginLeft: '6px',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
}));

const StudentEligibility = () => {
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [selectTermOption, setTermOption] = useState([]);
  const [selectCriteriaOption, setCriteriaOption] = useState([]);

  const [selectSectionOption, setSectionOption] = useState([]);
  const [filterCriteriaData, setFilterCriteriaData] = useState([]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [studentInfo, setStudentInfo] = useState({
    program:'',
    criteria:'',
    term:'',
    programPlan:'',
  });
  const [showData, setShowData] = useState(false);
  const [Department, setDepartment] = useState('');
  const [AcademicProgram, setAcademicProgram] = useState('');
  const [ProgramPlan, setProgramPlan] = useState('');
  const [term, setTerm] = useState('');
  const [Criteria, setCriteria] = useState('');
  const [maxDurationAllowedForEnrollment, setmaxDurationAllowedForEnrollment] =
    useState('');
  const [minDurationAllowedForEnrollment, setminDurationAllowedForEnrollment] =
    useState('');

  const [masterDialog, setMasterDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [promotionData, setPromotionData] = useState('');

  const ActionCell = ({ value, row }) => {
    return (
      <KenCheckbox
        name={`checkbox`}
        className={classes.checkbox}
        // checked={row.original.eligible === 'Eligible' ? true : false}
        value={value}
        onChange={(e) => handleChange(e, row)}
        color="primary"
      />
    );
  };

  const [columns, setColumn] = useState([]);
  useEffect(() => {
    if (studentInfo.criteria)
      getDataForStudentEnrolment(
        studentInfo.program,
        studentInfo.term,
        studentInfo.programPlan,
        studentInfo.criteria
      )
        .then((res) => {
          const filterData = [];

          if (res.data) {
            setShowData(true);

            for (const [key, value] of Object.entries(res.data)) {
              let object = {};
              object['id'] = key;
              object['contactName'] = value.contactName;
              value.criteriaFilterResultList.forEach((values, index) => {
                object[values.isCriteriaName] = values.isCriteriaFilterPassed;
                object[values.isCriteriaName + 'message'] = values.message;
              });
              if (value.cgpa !== null) {
                Object.entries(value.cgpa).forEach(([keyCGPA, valueCGPA]) => {
                  object[keyCGPA + '_CGPA'] = valueCGPA;
                });
              } else if (value.sgpa !== null) {
                Object.entries(value.sgpa).forEach(([keyCGPA, valueCGPA]) => {
                  object[keyCGPA + '_SGPA'] = valueCGPA;
                });
              } else if (value.acc !== null) {
                Object.entries(value.acc).forEach(([key, values]) => {
                  if (
                    key === 'Max_Duration_Allowed_For_Enrollment__c' ||
                    key === 'Min_Duration_Allowed_For_Enrollment__c'
                  )
                    object[key + '_Account'] = values;
                });
              }

              if (value.isCriteriaPassed === true) {
                object['eligible'] = 'Eligible';
                object['checked'] = true;
              } else {
                object['eligible'] = 'Not Eligible';
                object['checked'] = false;
              }
              if (value.subjectScoreTotal !== null) {
                if (value.subjectScoreTotal['Cut-OFF Grade 2']) {
                  object['Calculated_Letter_Grade__c_Subject Score'] =
                    value.subjectScoreTotal['Cut-OFF Grade 2'];
                  object['Calculated_Letter_Grade__c_Cutoff1'] = 0;
                } else if (value.subjectScoreTotal['Cut-OFF Grade 1']) {
                  object['Calculated_Letter_Grade__c_Cutoff1'] =
                    value.subjectScoreTotal['Cut-OFF Grade 1'];
                  object['Calculated_Letter_Grade__c_Subject Score'] = 0;
                } else if (value.subjectScoreTotal === 0) {
                  object['Calculated_Letter_Grade__c_Subject Score'] = 0;
                  object['Calculated_Letter_Grade__c_Cutoff1'] = 0;
                }
              }

              filterData.push(object);
            }
          }
          setData([...filterData]);
        })
        .catch((err) => {
          handleSnackbarOpen('error', err.message);
          setLoading(false);
        });
  }, [
    studentInfo.program,
    studentInfo.criteria,
    studentInfo.programPlan,
    studentInfo.term,
  ]);
  const handleChange = (e, row) => {
    setData((prev) => {
      return prev.map((single) => {
        if (single.id === row.original.id) {
          return { ...single, checked: e.target.checked };
        } else {
          return single;
        }
      });
    });
  };

  const handleChangeDepartment = (e) => {
    setStudentInfo({
      ...studentInfo,
      department: e.target.value,
      program: '',
      programPlan: '',
      term: '',
      criteria: '',
    });
    setDepartment(e.target.value);
    setTerm('');
    setCriteria('');
    setAcademicProgram('');
    setProgramPlan('');
    const ProgramOption = [];
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS[0][1].map((items) => {
      ProgramOption.push({
        label: items.AcademicProgramName,
        value: items.AcademicProgramId,
      });
    });
    setProgramOption(ProgramOption);
  };
  const handleChangeProgram = (e) => {
    setStudentInfo({ ...studentInfo, program: e.target.value });
    // For Program Plan
    const ProgramPlanOption = [];
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS2[0][1].map((items) => {
      ProgramPlanOption.push({
        label: items.ProgramPlanName,
        value: items.ProgramPlanId,
      });
    });
    setTerm('');
    setCriteria('');
    setAcademicProgram(e.target.value);
    setProgramPlan('');
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setStudentInfo({ ...studentInfo, programPlan: e.target.value });
    const TermOption = [];
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    setTerm('');
    setCriteria('');
    setProgramPlan(e.target.value);
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
      setTermOption(TermOption);
    }
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.value);
    setStudentInfo({ ...studentInfo, term: e.target.value });
    const SectionOption = [];
    const dataS = Object.entries(filterData.SectionsForEachTerm).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    setCriteria('');
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        SectionOption.push({
          label: items.SectionName,
          value: items.SectionName,
        });
      });
      setSectionOption(SectionOption);
    }
  };
  const handleChangeCriteria = (e) => {
    setCriteria(e.target.value);
    setStudentInfo({ ...studentInfo, criteria: e.target.value });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const Promoteallstudent = () => {
    const promotiondata = data
      .filter((datapromotion) => {
        if (
          datapromotion.eligible === 'Not Eligible' &&
          datapromotion.checked === true
        ) {
          return datapromotion;
        }
      })
      .map((name) => {
        return name.contactName;
      });

    if (promotiondata.length <= 0) {
      handleSnackbarOpen(
        'error',
        'Please select atleast one student to promote'
      );
    } else {
      setMasterDialog(true);
      setPromotionData(promotiondata);
    }
  };

  useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    // const instituteId = '0015j00000rgtHcAAI';
    getDataForCourseEnrolment(instituteId).then((res) => {
      const DepartmentOption = [];
      res.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });
      if (DepartmentOption) {
        getPromotionCriteriaDataFilter()
          .then((res) => {
            const CriteriaTypeOption = [];
            res.CriteriaType.map((item) => {
              CriteriaTypeOption.push({
                label: item.label,
                value: item.value,
              });
            });
            setCriteriaOption(CriteriaTypeOption);
          })
          .catch((err) => {
            handleSnackbarOpen('error', err.message);
            setLoading(false);
          });
      }
      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, [userDetails]);

  const Header = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ActionCell,
      disableGlobalFilter: true,
    },
    {
      Header: 'Name',
      accessor: 'contactName',
      disableGlobalFilter: false,
    },
  ];

  useEffect(() => {
    if (studentInfo.criteria) {
      setLoading(true);
      getstudentPromotionCriteriaData(
        studentInfo.program,
        studentInfo.term,
        studentInfo.criteria
      )
        .then((res) => {
          setLoading(false);
          if (res.success === 'false') {
            handleSnackbarOpen('error', res.message);
          } else {
            if (res.data[0].maxDurationAllowedForEnrollment) {
              setmaxDurationAllowedForEnrollment(
                res.data[0].maxDurationAllowedForEnrollment
              );
            }
            if (res.data[0].minDurationAllowedForEnrollment) {
              setminDurationAllowedForEnrollment(
                res.data[0].minDurationAllowedForEnrollment
              );
            }
            const filterData = [];
            res.data[0].CriteriaFilter.forEach((criteria) => {
              if (criteria.criteriaName === 'Cut-OFF Grade 1') {
                filterData.push({
                  Header: criteria.criteriaName,
                  accessor: criteria.filterField + '_Cutoff1',
                  disableGlobalFilter: false,
                  Cell: ({ value, row }) => {
                    return (
                      <Box>
                        {row.original['Cut-OFF Grade 1'] === false ? (
                          <Tooltip
                            disableFocusListener
                            disableTouchListener
                            title={
                              row.original['Cut-OFF Grade 1'] === false &&
                              row.original[criteria.criteriaName + 'message']
                            }
                          >
                            <Button
                              variant="primary"
                              className={
                                row.original['Cut-OFF Grade 1'] === false &&
                                classes.errorcell
                              }
                            >
                              {value}
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button variant="primary">{value}</Button>
                        )}
                      </Box>
                    );
                  },
                });
              } else {
                filterData.push({
                  Header: criteria.criteriaName,
                  accessor:
                    criteria.filterField + '_' + criteria.filterObjectType,
                  disableGlobalFilter: false,
                  Cell: ({ value, row }) => {
                    return (
                      <Box>
                        {row.original[criteria.criteriaName] === false ? (
                          <Tooltip
                            disableFocusListener
                            disableTouchListener
                            title={
                              row.original[criteria.criteriaName] === false &&
                              row.original[criteria.criteriaName + 'message']
                            }
                          >
                            <Button
                              variant="primary"
                              className={
                                row.original[criteria.criteriaName] === false &&
                                classes.errorcell
                              }
                            >
                              {value}
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button variant="primary">{value}</Button>
                        )}
                      </Box>
                    );
                  },
                });
              }
            });
            const eligible = {
              Header: 'Is Eligible',
              accessor: 'eligible',
              Cell: ({ value, row }) => {
                return (
                  <Box>
                    <Button
                      variant="primary"
                      className={
                        value === 'Eligible' ? classes.normal : classes.error
                      }
                    >
                      {value}
                    </Button>
                  </Box>
                );
              },
              disableGlobalFilter: false,
            };

            setColumn([...Header, ...filterData, eligible]);
            setFilterCriteriaData(res.data[0].CriteriaFilter);
          }
        })
        .catch((err) => {
          handleSnackbarOpen('error', err.message);
          setLoading(false);
        });
    }
  }, [studentInfo.criteria, studentInfo.program, studentInfo.term]);
  console.log('setColumnsetColumnsetColumn', columns);

  const handleSelectChange2 = () => {
    setDepartment('');
    setProgramOption([]);
    setProgramPlan('');
    setProgramPlanOption([]);
    setTermOption([]);
    setTerm('');
    setCriteriaOption([]);
    setCriteria('');
    setStudentInfo({
      program:'',
      criteria:'',
      term:'',
      programPlan:'',
    });
    setData([]);
    setShowData(false);
  }

  return (
    <Grid container xs={12}>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <KenDialog
        title={'Promotion confirmation'}
        open={masterDialog}
        handleClose={() => setMasterDialog(false)}
        negativeButtonClick={() => {
          setMasterDialog(false);
        }}
        positiveButtonClick={() => {
          setMasterDialog(false);
        }}
        maxWidth={'md'}
        positiveButtonText={'Save'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid className="custom-select-box">
          {promotionData.length <= 0 ? (
            <p>Would you like to promote all those selected students?</p>
          ) : (
            <>
              <p>
                The following students are not eligible for promotion based on
                the promotion criteria. Do you still want to continue?
              </p>
              <List className={classes.list}>
                {promotionData.length > 0 &&
                  promotionData.map((promotion) => {
                    return <ListItem>{promotion}</ListItem>;
                  })}
              </List>
            </>
          )}
        </Grid>
      </KenDialog>
      {loading && <KenLoader />}
      <div position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px' }}>
          <Typography className={classes.title}>Student Promotion</Typography>
        </Toolbar>
      </div>
      <div className={classes.courseList}>
        <Grid container xs={12} className={classes.facultyInfoSection}>
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Institute Department"
              optionalLabel={false}
              options={selectDepartmentOption}
              value={Department}
              // defaultSearchValue={studentInfo.department || ''}
              onChange={(e) => handleChangeDepartment(e)}
              placeholder="Institute Department"
              required
            />
          </Grid>
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Academic Program"
              optionalLabel={false}
              options={selectProgramOption}
              value={AcademicProgram}
              // defaultSearchValue={studentInfo.program || ''}
              onChange={(e) => handleChangeProgram(e)}
              placeholder="Academic Program"
              required
            />
          </Grid>
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Program Plan"
              optionalLabel={false}
              options={selectProgramPlanOption}
              value={ProgramPlan}
              // defaultSearchValue={studentInfo.programPlan || ''}
              onChange={(e) => handleChangeProgramPlan(e)}
              placeholder="Program Plan"
              required
            />
          </Grid>
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Term"
              optionalLabel={false}
              options={selectTermOption}
              value={term}
              // defaultSearchValue={studentInfo.term || ''}
              onChange={(e) => handleChangeTerm(e)}
              placeholder="Term"
              required
            />
          </Grid>
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Criteria"
              optionalLabel={false}
              options={selectCriteriaOption}
              value={Criteria}
              // defaultSearchValue={studentInfo.criteria || ''}
              onChange={(e) => handleChangeCriteria(e)}
              placeholder="Criteria"
              required
            />
          </Grid>

          <Button
            variant="contained"
            color="primary"
            className={classes.addButton}
            onClick={handleSelectChange2}
          >
            Clear All
          </Button>
        </Grid>
      </div>
      {showData ? (
        <>
          <Grid container xs={12}>
            <Grid xs={12} className={classes.filterBy}>
              {' '}
              <b>Filter By :</b>
            </Grid>
            <Grid container xs={12} className={classes.criteriafilter}>
              {filterCriteriaData.length > 0 &&
                filterCriteriaData.map((Criteria) => {
                  if (
                    Criteria.criteriaName ===
                    'Maximum Duration Allowed From Program Enrollment'
                  ) {
                    return (
                      <Grid xs={4}>
                        {Criteria.criteriaName}
                        {Criteria.filterOperator}
                        {maxDurationAllowedForEnrollment}
                      </Grid>
                    );
                  } else if (
                    Criteria.criteriaName ===
                    'Minimum Duration Allowed From Program Enrollment'
                  ) {
                    return (
                      <Grid xs={4}>
                        {Criteria.criteriaName}
                        {Criteria.filterOperator}
                        {minDurationAllowedForEnrollment}
                      </Grid>
                    );
                  } else {
                    return (
                      <Grid xs={4}>
                        {Criteria.criteriaName}
                        {Criteria.filterOperator}
                        {Criteria.criteriaValue}
                      </Grid>
                    );
                  }
                })}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.resposiveTable}>
              <Box className="cardlsitbox">
                <div className="facultyenrolltable" style={{ width: '100%' }}>
                  <KenCard elevation={0}>
                    <KenGrid
                      columns={columns}
                      data={data}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                    />
                  </KenCard>
                </div>
              </Box>
            </Grid>
          </Grid>
          <KenButton
            label="Promote"
            onClick={() => Promoteallstudent()}
            variant="primary"
            // disabled={disabled}
            className={classes.promoteAllBtn}
          />
        </>
      ) : null}
    </Grid>
  );
};

export default StudentEligibility;
